import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const SalesPlanApi = {
  getCalculationsOnProductUpdate: async (params: t.IUpdateProductCalculationsParams) => {
    const { id, businessPlanId, product, unit } = params;
    const { data } = await businessPlanAxios.put<t.ISalesPlanCalculationResponse>(
      `/${businessPlanId}/product/${id}/update/salesplan/${unit}`,
      product,
    );
    return data;
  },
  getAllProductsCalculations: async (params: t.IGetAllProductsCalculationsParams) => {
    const { businessPlanId, unit } = params;
    const { data } = await businessPlanAxios.get<t.ISalesPlanCalculationResponse>(
      `/${businessPlanId}/product/salesplan/${unit}`,
    );
    return data;
  },
};
